import s from './Decorations.module.css';
import { ReactSVG } from 'react-svg';
import { hideDecorativeSvg } from '@/lib/a11y';
import { usePathname } from 'next/navigation';
import { useState, useCallback, useEffect } from 'react';
import useIsMobile from '@/hooks/use-is-mobile';

// Strip locale prefix to get the base path
function getBasePath(pathname: string): string {
  if (pathname.startsWith('/en/')) return pathname.slice(3);
  if (pathname === '/en') return '/';
  return pathname;
}

const Decorations = () => {
  const [top, setTop] = useState<number | undefined>();
  const rawPathname = usePathname();
  const pathname = getBasePath(rawPathname);
  const isMobile = useIsMobile();

  const isHome = pathname === '/';
  const isMasterplan = pathname === '/masterplan';
  const isClubDePlaya = pathname === '/club-de-playa';
  const isAreasVerdes = pathname === '/parques-y-areas-verdes';
  const isServicios = pathname === '/servicios';

  const getMasterplanOffset = useCallback(() => {
    const masterplanBlock = document.getElementById('masterplanBlock');
    if (masterplanBlock) {
      const rectMasterplan = masterplanBlock.getBoundingClientRect();
      return rectMasterplan.top + window.scrollY;
    }
    return undefined;
  }, []);

  const getDisplayOffset = useCallback(() => {
    const displayBlocks = document.querySelectorAll('#displayBlock');
    if (displayBlocks) {
      const displayBlock = displayBlocks.length > 1 ? displayBlocks[1] : undefined;
      if (displayBlock) {
        const rectDisplay = displayBlock.getBoundingClientRect();
        return rectDisplay.top + window.scrollY;
      }
    }
    return undefined;
  }, []);
  useEffect(() => {
    const timeout = setTimeout(() => {
      const offsetTopMasterplan = getMasterplanOffset();
      const offsetTopDisplay = getDisplayOffset();
      if (isHome) {
        setTop(offsetTopDisplay);
      } else if (isMasterplan || isAreasVerdes) {
        setTop(offsetTopMasterplan);
      } else if (isServicios && isMobile === false) {
        setTop(offsetTopDisplay);
      } else if (isClubDePlaya && isMobile === false) {
        setTop(offsetTopDisplay);
      }
    }, 1000);

    return () => clearTimeout(timeout);
  }, [
    isHome,
    isClubDePlaya,
    isMasterplan,
    isAreasVerdes,
    getMasterplanOffset,
    getDisplayOffset,
    isMobile
  ]);

  const hidden = isMobile ? '95px' : '295px';

  return (
    <>
      {top !== undefined && (
        <div
          style={{ top: `calc(${top}px - ${hidden})` }}
          className={`${s.svg_container} ${isMasterplan || isAreasVerdes ? s.svg_container__blue : ''} ${isClubDePlaya ? s.svg_container__left : ''}`}>
          <ReactSVG src="/icons/logo.svg" beforeInjection={hideDecorativeSvg} />
        </div>
      )}
    </>
  );
};

export default Decorations;
